import { Button, Space } from "@arco-design/web-react";
import { Navigate, useNavigate, useParams } from "react-router-dom";

import { useCustomerQuoteEntryRedirect } from "..";

/** 读取统一异常对象上的后端业务码。 */
function readErrorCode(error: unknown): string | null {
  if (error && typeof error === "object" && "code" in error) {
    const value = (error as { code?: unknown }).code;
    return typeof value === "string" ? value : null;
  }
  return null;
}

/** 已定稿核价进入报价的中转页，成功后替换历史记录。 */
export function CustomerQuoteEntryRedirectPage() {
  const { budgetOrderId } = useParams<{ budgetOrderId: string }>();
  const navigate = useNavigate();
  const query = useCustomerQuoteEntryRedirect(budgetOrderId);
  const returnToBudget = () => navigate(`/quote/budgets/${budgetOrderId ?? ""}`, { replace: true });
  const renderRecovery = (message: string, returnToBudgetFirst = false) => (
    <div role="alert">
      <p>{message}</p>
      {returnToBudgetFirst ? (
        <Space>
          <Button type="primary" onClick={returnToBudget}>返回行程核价</Button>
          <Button onClick={() => void query.refetch()}>重新检查</Button>
        </Space>
      ) : (
        <Space>
          <Button type="primary" onClick={() => void query.refetch()}>重新尝试</Button>
          <Button onClick={returnToBudget}>返回行程核价</Button>
        </Space>
      )}
    </div>
  );
  if (query.fetchStatus === "paused") {
    return renderRecovery("当前网络不可用，暂时无法生成行程报价。请恢复网络后重新尝试。");
  }
  if (query.fetchStatus !== "idle") return <div role="status">正在从定稿核价生成对客报价…</div>;
  if (query.error) {
    if (readErrorCode(query.error) === "CUSTOMER_QUOTE_SOURCE_NOT_FINALIZED") {
      return renderRecovery(
        "来源核价尚未定稿，暂不能生成行程报价。请先返回行程核价完成定稿。",
        true,
      );
    }
    return renderRecovery(
      readErrorCode(query.error) === "CUSTOMER_QUOTE_SCHEMA_NOT_READY"
        ? "对客报价数据表尚未就绪，请联系管理员完成初始化后重试。"
        : "无法进入对客报价，请稍后重试。",
    );
  }
  if (query.data) return <Navigate to={query.data.redirectTo} replace />;
  return <div role="status">正在从定稿核价生成对客报价…</div>;
}
